import { normaliseDateQtyInputField, removeEmptyExpiryDates } from "./expiryDateHelper";
import {
  OrderProductCheckIn,
  OrderProductCheckInInputField,
  NonOrderProductCheckIn,
  NonOrderProductCheckInInputField
} from "src/types";

function normaliseProductCheckInInputField<
  T extends OrderProductCheckInInputField | NonOrderProductCheckInInputField,
  F extends OrderProductCheckIn | NonOrderProductCheckIn
>(productCheckInInputField: T): F {
  const hasWarehouseSplit = productCheckInInputField.hasWarehouseSplit;
  const receivedUkQty = hasWarehouseSplit ? Number(productCheckInInputField.receivedUkQty) || 0 : undefined;
  const receivedEuQty = hasWarehouseSplit ? Number(productCheckInInputField.receivedEuQty) || 0 : undefined;
  const receivedQty = hasWarehouseSplit
    ? (receivedUkQty ?? 0) + (receivedEuQty ?? 0)
    : Number(productCheckInInputField.receivedQty);

  const filteredExpiryDates = productCheckInInputField.expiryDates
    ? removeEmptyExpiryDates(productCheckInInputField.expiryDates)
    : [];
  const normalisedExpiryDates = filteredExpiryDates.map((expiryDateEntry) => ({
    ...normaliseDateQtyInputField(expiryDateEntry),
    receivedQty: Number(expiryDateEntry.qty || receivedQty)
  }));

  return {
    productId: productCheckInInputField.productId?.trim() || undefined,
    productName: "productName" in productCheckInInputField ? productCheckInInputField.productName?.trim() : undefined,
    orderQty: "orderQty" in productCheckInInputField ? productCheckInInputField.orderQty : undefined,
    confirmedQty: "confirmedQty" in productCheckInInputField ? productCheckInInputField.confirmedQty : undefined,
    ukQty: "ukQty" in productCheckInInputField ? productCheckInInputField.ukQty : undefined,
    euQty: "euQty" in productCheckInInputField ? productCheckInInputField.euQty : undefined,
    receivedQty,
    receivedUkQty,
    receivedEuQty,
    expiryDates: normalisedExpiryDates.length ? normalisedExpiryDates : undefined
  } as F;
}

export function normaliseOrderProductCheckInInputField(
  orderProductCheckInInputField: OrderProductCheckInInputField
): OrderProductCheckIn {
  return normaliseProductCheckInInputField(orderProductCheckInInputField);
}

export function normaliseNonOrderProductCheckInInputField(
  nonOrderProductCheckInInputField: NonOrderProductCheckInInputField
): NonOrderProductCheckIn {
  return normaliseProductCheckInInputField(nonOrderProductCheckInInputField);
}
